import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GridOptions } from 'ag-grid';
import { Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { AdvancedLookupComponent } from '../../models/lookup';
import { DateHelper } from '../../models/NgDateCustomAdapter';
import { AuthService } from '../../services/auth.service';
import { TasacionesService } from '../../services/tasaciones.service';
import { CellDateFormatterComponent } from '../cell-date-formatter/cell-date-formatter.component';
import { CellHyperlinkCustomComponent } from '../cell-hyperlink-custom/cell-hyperlink-custom.component';
import { CellImageFormatterComponent } from '../cell-image-formatter/cell-image-formatter.component';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-tasaciones',
  templateUrl: './tasaciones.component.html',
  styleUrls: ['./tasaciones.component.css']
})
export class TasacionesComponent implements OnInit, AdvancedLookupComponent {

  private title = 'Tasaciones';
  private idEstadoFrom: number;
  private idEstadoTo: number;
  private idEstado: number;
  isChecked: boolean;
  //private skip: number;

  public baseEditUrl = "/tasacion/edit/";
  public baseEditText = "Editar";

  public translate: TranslateService;
  public columnDefs: any[];
  public rowData: any;
  searchTerm: FormControl = new FormControl();
  public gridApi;
  public tooltipShowDelay = 500
  // public gridApi;
  gridOptions: GridOptions;
  isModal: false;

  createColumnDef() {
    const columnDefs = [
      {
        headerName: '',
        field: 'id', suppressFilter: true, suppressSorting: true,
        cellRendererFramework: CellHyperlinkCustomComponent,
        cellRendererParams: {
          destUrl: '/tasacion/edit/', hyperlinkText: 'Abrir tasación',
          iconClass: 'fa-lg fas fa-file-alt text-success'
        },
        pinned: 'left',
        width: 55,
        hide: this.isModal
      },
      { headerName: 'Of. Fact.', headerTooltip: "Oficina facturación", field: 'oficinaFacturacion.oficinaCode', tooltipField: 'oficinaFacturacion.oficinaCode', width: 70 },
      { headerName: this.translate.instant('tasaciones.header_codtasacion'), headerTooltip: "Código tasación", field: 'codigoTasacion', tooltipField: 'codigoTasacion', width: 120 },
      {
        headerName: this.translate.instant('tasaciones.referenciaBanco'), headerTooltip: this.translate.instant('tasaciones.referenciaBanco'),
        field: 'referenciaBanco', tooltipField: 'referenciaBanco', width: 110
      },
      {
        headerName: 'Nº Presupuesto', headerTooltip: 'Nº presupuesto',
        field: 'nPresupuesto', tooltipField: 'nPresupuesto', width: 100
      },
      {
        headerName: this.translate.instant('tasaciones.header_cliente'), headerTooltip: this.translate.instant('tasaciones.header_cliente'),
        field: 'cliente.displayName', tooltipField: 'cliente.displayName', minWidth: 350
      },
      {
        headerName: this.translate.instant('tasacion_edit.camp_solicitante'), headerTooltip: this.translate.instant('tasacion_edit.camp_solicitante'),
        field: 'clienteSolicitante.displayName', tooltipField: 'clienteSolicitante.displayName', minWidth: 350
      },
      {
        headerName: this.translate.instant('tasaciones.header_tipoInmueble'), headerTooltip: this.translate.instant('tasaciones.header_tipoInmueble'),
        field: 'tipoInmueble.nombre', tooltipField: 'tipoInmueble.nombre', width: 120
      },
      {
        headerName: 'Localidad', headerTooltip: "Localidad", field: 'localidad', tooltipField: 'localidad', width: 100
      },
      {
        headerName: 'F. Alta', headerTooltip: "Fecha Alta", field: 'createdDate', cellRendererFramework: CellDateFormatterComponent, width: 100
      },
      {
        headerName: this.translate.instant('tasaciones.deadline'), headerTooltip: "Deadline", field: 'deadline',
        cellRendererFramework: CellDateFormatterComponent, cellStyle: function (params) {
          const now = new Date();
          const deadline = new Date(params.value);
          deadline.setUTCHours(0, 0, 0, 0);
          let color = '';
          if (deadline >= now) {
            color = 'green'
          } else {
            color = '#D40501' //color rojo
          }

          return { color: color }
        }, width: 100
      },
      { headerName: "C. ABC", headerTooltip: "Categorización ABC", field: 'categorizacionABC', tooltipField: 'categorizacionABC', width: 50 },
      {
        headerName: this.translate.instant('tasaciones.header_estado'), headerTooltip: this.translate.instant('tasaciones.header_estado'), field: 'estadoIncidencia', tooltipField: 'estadoIncidencia',
        cellRendererFramework: CellImageFormatterComponent, minWidth: 200, maxWidth: 300
      },
      {
        headerName: this.translate.instant('tasaciones.header_estadoFacturado'), headerTooltip: this.translate.instant('tasaciones.header_estadoFacturado'),
        field: 'estadosFacturacion.nombre', tooltipField: 'estadosFacturacion.nombre', width: 140
      },
      {
        headerName: this.translate.instant('tasaciones.header_tecnico'), headerTooltip: this.translate.instant('tasaciones.header_tecnico'),
        field: 'tasador.nombreCompleto', tooltipField: 'tasador.nombreCompleto', width: 130
      },
      {
        headerName: "Imp. Presupuestado", headerTooltip: this.translate.instant('tasaciones.header_importePresupuestado'),
        field: 'importePresupuestado', tooltipField: 'importePresupuestado', width: 80,
      },
      {
        headerName: "Tiempo consumido", headerTooltip: 'Tiempo consumido',
        field: 'tiempoConsumido', width: 115,
      }
    ];

    return columnDefs;
  }



  constructor(private _TasacionesService: TasacionesService, private _router: Router, private _route: ActivatedRoute,
    public _authService: AuthService, _translateService: TranslateService, private dateHelper: DateHelper,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data) {
      this.isModal = data.isModal;
    }

    this.idEstadoFrom = 0;
    this.idEstadoTo = 0;
    this.idEstado = 0;
    this.isChecked = true;

    this.translate = _translateService;

    this.columnDefs = this.createColumnDef();
    this.gridOptions = {
      floatingFiltersHeight: 50
    }

    if (this._route.snapshot.params['idEstado']) {
      this.idEstado = this._route.snapshot.params['idEstado'];
    }

  }
  getSelectedItem() {
    if (this.gridApi.getSelectedNodes().length === 1) {
      const selectedRow = this.gridApi.getSelectedNodes()[0];
      // console.log(selectedRow)
      const rowid = selectedRow.data.id;
      // console.log(rowid);
      return rowid;

    } else {
      return null;
    }
  }

  ngOnInit() {
    console.log(this._route.data);
    this._route.data
      .subscribe(v => {
        if (v.idEstadoTo !== undefined) {
          this.idEstadoFrom = v.idEstadoFrom;
          this.idEstadoTo = v.idEstadoTo;
        }
      });

    this.translate.use(this.translate.currentLang);
    this.getTasaciones();

    this.searchTerm.valueChanges.pipe(debounceTime(400)).subscribe(data => {
      this.getTasaciones();
    });
  }

  onGridReady(params) {
    this.gridApi = params.api;
  }

  public getTasaciones() {

    let svc: Observable<any>;

    if (this.searchTerm.value != null) {
      svc = this._TasacionesService.getTasacionesFiltered(this.searchTerm.value);
    } else {
      if (this.idEstadoTo !== 0) {
        svc = this._TasacionesService.getTasacionesByEstados(this.idEstadoFrom, this.idEstadoTo, this.isChecked);
      } else if (this.idEstado !== 0) {
        svc = this._TasacionesService.getTasacionesByEstado(this.idEstado, this.isChecked);
      } else {
        svc = this._TasacionesService.getTasacionesCheckedYear(this.isChecked);
      }
    }

    svc.subscribe(data => {
      this.rowData = data;
    }, (err) => {
      console.error('Error al recuperar datos de clientes');
    });
  }

  changeValue(value) {
    this.isChecked = !value;
    this.getTasaciones();
  }

  public onRowClicked(e) {
    if (e.event.target !== undefined) {
      const data = e.data;
      const actionType = e.event.target.getAttribute('data-action-type');

      switch (actionType) {
        case 'remove':
          return this.onActionRemoveClick(data);

      }
    }
  }

  public onActionRemoveClick(data: any) {
    this.delete(data.id);
  }

  delete(id) {
    const ans = confirm(`Quieres eliminar el registro con Id: ${id}`);
    if (ans) {
      this._TasacionesService.removeTasacion(id).subscribe((data) => {
        this.getTasaciones();
      });
    }
  }

  // calcularTiempoConsumido(params) {
  //   let createdDate =  new Date(params.data.createdDate);
  //   createdDate.setHours(createdDate.getHours() + 2);
  //   let now = new Date();
  //   if(params.data.estadoId == ValoresEstadoTasacion.InformeEntregado.toString()) {
  //     if(params.data.fechaInformeEntregadoCliente == null || params.data.fechaInformeEntregadoCliente == "")
  //       return null;
  //     now =  new Date(params.data.fechaInformeEntregadoCliente);
  //   }

  //   const diffms = now.getTime() - createdDate.getTime();

  //   const msDay = 24 * 60 * 60 * 1000; // Milisegundos en un día
  //   const diffDays = Math.floor(diffms / msDay);

  //   const msHr = 60 * 60 * 1000; // Milisegundos en una hora
  //   const DiffHrs = Math.floor((diffms % msDay) / msHr);

  //   return `${diffDays}d ${DiffHrs}h`; // Este valor se mostrará en la celda "Tiempo consumido"
  // }
}
